module.exports = __webpack_public_path__ + "static/media/branches_move.e567f532.gif";